import { defineStore } from "pinia";
import { ASPECT_RATIOS_FOR_GENERATE_SIMILAR, outputTypes } from "@/constants/Inputs";
import { v4 as uuidv4 } from "uuid";

interface DynamicCreativeState {
  referenceFileUrl: string | null;
  uploadedAssets: string[];
  selectedAssets: string[];
  outputS3Url: string;
  creativeTemplateId: number | null;
  userPrompt: string | null;
  aspectRatio: string;
  isPromptOptimizationNeeded: boolean;
  outputType: string;
  uniqueId: string;
}

export const useDynamicCreativeStore = defineStore("dynamicCreative", {
  state: (): DynamicCreativeState => ({
    uploadedAssets: [],
    selectedAssets: [],
    referenceFileUrl: null,
    outputS3Url: "",
    creativeTemplateId: null,
    userPrompt: null,
    aspectRatio: ASPECT_RATIOS_FOR_GENERATE_SIMILAR[0].id,
    isPromptOptimizationNeeded: true,
    outputType: outputTypes.ad,
    uniqueId: "",
  }),
  actions: {
    setReferenceFileUrl(referenceFile: string | null) {
      this.referenceFileUrl = referenceFile;
    },
    setAssetUrls(urls: string[]) {
      this.selectedAssets = urls;
    },
    setUploadedAssets(urls: string[]){
      this.uploadedAssets = urls;
    },
    addSelectedAssetS3Url(url: string) {
      this.selectedAssets.push(url);
    },
    addUploadedAssetS3Url(url: string) {
      this.uploadedAssets.push(url);
    },
    removeSelected3Url(url: string) {
      this.selectedAssets = this.selectedAssets.filter((asset) => asset !== url);
    },
    removeUploaded3Url(url: string) {
      this.uploadedAssets = this.uploadedAssets.filter((asset) => asset !== url);
    },
    setOutputS3Url(url: string) {
      this.outputS3Url = url;
    },
    setCreativeTemplateId(id: number | null) {
      this.creativeTemplateId = id;
    },
    setUserPrompt(prompt: string) {
      const trimmedPrompt = prompt.trim();
      this.userPrompt = trimmedPrompt.length > 0 ? trimmedPrompt : null;
    },
    setAspectRatio(aspectRatio: string) {
      this.aspectRatio = aspectRatio;
    },
    setUniqueId(id?: string) {
      if (id) {
        this.uniqueId = id;
        return;
      }
      this.uniqueId = uuidv4();
    },
    setIsPromptOptimizationNeeded(val: boolean) {
      this.isPromptOptimizationNeeded = val;
    },
    setOutputType(type: string) {
      this.outputType = type;
    },
    reset() {
      this.selectedAssets = [];
      this.uploadedAssets = [];
      this.referenceFileUrl = null;
      this.outputS3Url = "";
      this.creativeTemplateId = null;
      this.userPrompt = null;
      this.aspectRatio = ASPECT_RATIOS_FOR_GENERATE_SIMILAR[0].id;
      this.isPromptOptimizationNeeded = true;
      this.outputType = outputTypes.ad;
      this.uniqueId = "";
    },
  },
});
